export default __webpack_public_path__ + "static/media/Equipe7.a57c4906.png";